<template>
    <button type="submit" @click="clicked">
        <i v-if="saving" class="fa fa-refresh fa-spin fa-fw"></i>
        <span>{{ buttonText }}</span>
    </button>
</template>

<script>
    export default {
        data(){
            return {
                buttonText: this.defaultText
            }
        },

        watch: {
            saving(val) {
                if (val == false) {
                    this.buttonText = this.finishedText;

                    setTimeout(() => {
                        this.buttonText = this.defaultText;
                    }, 750);

                    return;
                }

                this.buttonText = this.duringText;

            }
        },
        methods: {
            clicked() {
                this.$emit('clicked');
            }
        },
        props: {
            saving: {
                default: false
            },
            defaultText: {
                default: 'save'
            },
            duringText: {
                default: 'saving'
            },
            finishedText: {
                default: 'Finished !'
            }
        }
    }
</script>
